'use strict';

// A card's domicile address (metadata.shipping); {} when missing or unparseable
module.exports = function parseCardShipping(card) {
  try {
    const shipping = JSON.parse((card && card.metadata && card.metadata.shipping) || '{}');
    return shipping && typeof shipping === 'object' ? shipping : {};
  } catch (e) {
    return {};
  }
};
